import { CSSProperties } from 'react';
import { QuotationData } from './Quotations';

export interface QuotationAccordionProps {
    handleNext: (index: number, updatedItems?: any) => void;
    index: number;
    quoteData?: QuotationData;
    updateProducts?: () => void;
}

export type CustomItem = {
    id?: number;
    name: string;
    net_price: number;
    quantity: number;
    unit?: string;
    tax: number;
    gross_price?: number;
    margin?: number;
};

export interface QuotationCreateProps {
    name: string;
    items: QuotationCreateItem[];
}

export type QuotationCreateItem = {
    sku: string;
    quantity: number;
};

export interface QuotationCreateResp {
    id: number;
    user_id: number;
    name: string;
    validUntil: string;
    comment_1: string;
    comment_2: string;
    created_at: string;
    use_logo: boolean;
}

export type QuotationDetailsProps = {
    valid_from?: string;
    valid_until?: string;
    comment_1?: string;
    name?: string;
};

export type QuotationUserProps = {
    company: string;
    tax_number: string;
    name: string;
    phone: string;
    country: string;
    postcode: string;
    city: string;
    address1: string;
    address2: string;
    project_name?: string;
};

export interface QuotationProductsUpdateProps {
    index: number;
    id: number;
    item: {
        id: number;
        sku?: string;
        quantity?: number;
        margin?: number;
        customs?: CustomItem[];
    };
}

export type QuotationSummaryProps = {
    comment_2: string;
    use_logo: boolean;
};

export interface QuotationSummaryProdTableItem {
    name: string;
    image: string;
    quantity: number;
    net_unit_price: number;
    net_price: number;
    tax: number;
    gross_price: number;
    custom_items: CustomItem[];
    price_margin: number;
    unit: string;
}

export enum QuotationSummaryProdTableItemType {
    PRODUCT,
    CUSTOM_ITEM,
}

export interface QuotationSummaryProdTableItemWithType
    extends QuotationSummaryProdTableItem {
    type: QuotationSummaryProdTableItemType;
}

export interface QuotationSummariesTableItem {
    net_total: number;
    tax: number;
    gross_total: number;
}

export interface QuotationUpdateProps {
    quotationId: number;
    products: { items: QuotationCreateItem[] };
}

export interface QuotationMarginProps {
    margin: number;
    net_price: number;
    handleChange: (data: { margin: number }) => void;
    orientation?: CSSProperties['flexDirection'];
}

export interface QuotationProductsForm {
    items: QuotationData['items'];
}
